import { FaIcon } from '@ifixit/ui/components/icon';
import initializeComponent from 'Shared/react-initialize';
import { useTranslations } from '@ifixit/i18n/hooks';
import type { TranslationFunction } from '@ifixit/i18n/types';
import { Join } from './Join';

export const JoinPage = ({ privacyPolicyUrl }: { privacyPolicyUrl: string }) => {
   const t = useTranslations('Login');
   const source = new URLSearchParams(window.location.search).get('source');

   return (
      <>
         <style>{`:where(body) { background-color: var(--color-gray-50); } @media screen { :where(.dark body) { background-color: var(--color-gray-950); } }`}</style>
         <div
            className="my-8 md:my-14 md:gap-8 gap-4 flex flex-col md:flex-row items-center justify-center"
            data-testid="joinContainer"
         >
            {source === 'fixbot' ? <FixbotLeftContent t={t} /> : <JoinLeftContent t={t} />}
            <Join privacyPolicyUrl={privacyPolicyUrl} />
         </div>
         {(window as any).App?.dataProtectionMessage && (
            <p
               dangerouslySetInnerHTML={{
                  __html: (window as any).App.dataProtectionMessage,
               }}
            />
         )}
      </>
   );
};

const FixbotLeftContent = ({ t }: { t: TranslationFunction }) => (
   <div className="font-base md:w-[416px] flex flex-col items-center gap-6">
      <img
         src="https://assets.cdn.ifixit.com/static/images/fixbot-join.svg"
         alt="FixBot"
         className="h-[102px] w-[80px] md:h-[128px] md:w-[100px]"
      />
      <div className="flex flex-col gap-1.5 text-center">
         <h2 className="text-2xl md:text-[30px] font-medium text-gray-800 dark:text-foreground">
            {t('fixbotJoinHeader')}
         </h2>
         <p className="text-sm text-gray-900 dark:text-foreground">{t('fixbotDescription')}</p>
      </div>
      <div className="flex flex-col gap-3 text-sm">
         <div className="flex items-center gap-1.5">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-brand-50">
               <FaIcon name="brain-circuit" className="text-base text-brand-500" />
            </div>
            {t('fixbotDiagnose')}
         </div>
         <div className="flex items-center gap-1.5">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-brand-50">
               <FaIcon name="camera" className="text-base text-brand-500" />
            </div>
            {t('fixbotVisualAnalysis')}
         </div>
         <div className="flex items-center gap-1.5">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-brand-50">
               <FaIcon name="books" className="text-base text-brand-500" />
            </div>
            {t('fixbotRepairKnowledge')}
         </div>
      </div>
   </div>
);

const JoinLeftContent = ({ t }: { t: TranslationFunction }) => (
   <div className="font-base md:w-[416px]">
      <h2 className="text-2xl md:text-3xl font-medium max-sm:text-center">
         {t('joinTheCommunity')}
      </h2>
      <div className="mt-6 space-y-4 flex flex-col text-base">
         <div className="flex items-center">
            <FaIcon
               name="screwdriver-wrench"
               family="duotone"
               className="text-[24px] text-brand-500 my-auto mr-2"
            />
            {t('learnFromFixers')}
         </div>
         <div className="flex items-center">
            <FaIcon
               name="pen-to-square"
               family="duotone"
               className="text-[24px] text-brand-500 my-auto mr-2"
            />
            {t('shareYourExpertise')}
         </div>
         <div className="flex items-center">
            <FaIcon
               name="certificate"
               family="duotone"
               className="text-[24px] text-brand-500 my-auto mr-2"
            />
            {t('participateToEarnReputation')}
         </div>
      </div>
   </div>
);

initializeComponent('JoinPage', JoinPage);
